import { memo } from 'react';
import { Header, VStack } from '@direct-frontend/components';
import { type ErrorBlankProps } from './lib/types';

/**
 * Базовый элемент отображения ошибки
 * @kind component
 */
export const ErrorBlank = memo<ErrorBlankProps>(function ErrorBlank({
    'data-testid': dataTestId = 'ErrorBlank',
    header,
    title,
    subtitle,
    controls,
}) {
    const hasControls = Boolean(controls);

    return (
        <VStack data-testid={dataTestId} gap="28" alignItems="center">
            <VStack gap="20" alignItems="center">
                {header}
                {title && (
                    <Header level="h3" caption={subtitle} textAlign="center">
                        {title}
                    </Header>
                )}
            </VStack>
            {hasControls && <VStack gap="16">{controls}</VStack>}
        </VStack>
    );
});
